import Vue from "vue";
import Router from "vue-router";
const Home = () => import('@/components/Home.vue')
const Chime = () => import('@/components/Chime.vue')
const Ministrare = () => import('@/components/Ministrare.vue')
const FormCreator = () => import('@/components/FormCreator.vue')
const ThoughtBubble = () => import('@/components/ThoughtBubble.vue')
//const Resume = () => import('@/assets/files/AMunoz_Resume.pdf')
//import Home from "@/components/Home.vue"

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: "/",
            new: "home",
            component: Home,
            meta: {

            }
        },
        {
            path: "/Chime",
            new: "Chime",
            component: Chime,
            meta: {

            }
        },
        {
            path: "/Ministrare",
            new: "Ministrare",
            component: Ministrare,
            meta: {

            }
        },
        {
            path: "/FormCreator",
            new: "FormCreator",
            component: FormCreator,
            meta: {

            }
        },
        {
            path: "/ThoughtBubble",
            new: "ThoughtBubble",
            component: ThoughtBubble,
            meta: {

            }
        },
        {
            path: "/GitHub",
            new: "GitHub",
            component: () => {
               window.open('https://github.com/A-Munoz',"_blank") 
            },
            meta: {

            }
        },
        {
            path: "/Resume",
            new: "Resume",
            component: () => {
                window.open('./assets/static/AMunoz_Resume.pdf',"_blank") 
             },
            meta: {

            }
        },
    ],
    scrollBehavior (to, from, savedPosition) {
       if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
      },

});
